<template>
    <section v-if="getContacts">
        <div id="container-contacts-form" class="container d-flex">
            <div class="text-align-start formHeader">
                <img src="/imgs/icons/adv-logo-sm.png" alt="Advance Management Logo" style="max-width: 2em; margin-right: .5em">
                <span style="vertical-align: middle; font-weight: 600">Contatos</span>
            </div>
            <div id="div-title">
                <i class="fa fa-address-book fa-2x" aria-hidden="true" style="color: rgb(28,134,154)"></i>
                <h2 id="container-title">Cadastro de Contatos</h2>
            </div>
            <form action="" id="contacts-form">
                <div class="input-group">
                    <label for="contactName">Nome</label>
                    <input 
                        class="form-control" 
                        name="contactName" 
                        type="text" 
                        v-model="contact.name" 
                        placeholder="Insira o nome do contato" 
                        required>
                </div>

                <div class="input-group">
                    <label for="contactPhone">Telefone</label>
                        <vue-tel-input 
                            id="phone-input" 
                            :inputOptions="options" 
                            defaultCountry="BR"
                            mode="international" 
                            v-model="contact.phone">
                        </vue-tel-input>
                </div>

                <div class="input-group" v-if="lengthTipo > 1">
                  <label for="contactStatus">Tipo</label>
                  <select class="form-control" name="contactStatus" id="contactStatus" v-model="contact.status">
                    <option value="" selected disabled>Selecione...</option>
                    <option v-for="(value, key) in select_tipo" :key="key" :value="value.id">{{ value.name }}</option>
                  </select>
                </div>

                <div class="input-group" v-if="contact.status == 2">
                  <label for="contactEmpresa">Empresa</label>
                  <input 
                    class="form-control" 
                    name="contactNamePaciente" 
                    type="text" 
                    v-model="contact.empresa" 
                    placeholder="Insira o nome da empresa" 
                    >
                </div>

                <div class="input-group" v-if="contact.status == 2">
                  <label for="contactEmail">E-mail</label>
                  <input 
                    class="form-control" 
                    name="contactNamePaciente" 
                    type="text" 
                    v-model="contact.email" 
                    placeholder="Insira o E-mail" 
                    @blur="validateEmail"
                    >
                    
                    <p class="mt-2" v-if="contact.email && !emailValid" style="color: red;">
                        Por favor, insira um e-mail válido.
                    </p>
                </div>

                <div class="input-group">
                    <label for="group">Grupo</label>
                    <input 
                        class="form-control" 
                        name="wallet_group" 
                        type="text" 
                        v-model="contact.wallet_group"
                        required>
                </div>

                <div class="input-group" v-if="lengthFilter > 1 && contact.status == 2">
                  <label for="contactFilter">Filtro</label>
                  <select class="form-control" name="contactFilter" id="contactFilter" v-model="contact.filter">
                    <option value="" selected  disabled>Selecione...</option>
                    <option v-for="(value, key) in select_filter" :key="key" :value="value.id">{{ value.name }}</option>
                  </select>
                </div>

                <div class="input-group mt-2" v-if="contact.status == 2">
                    <select class="form-control mr-3 ml-3" name="id-cpf" id="id-cpf" v-model="idCpf" style="flex: 1">
                        <option value="id" selected>ID</option>
                        <option value="cnpj">CNPJ</option>
                        <option value="cpf">CPF</option>
                    </select>
                    <input class="form-control"
                        name="contactKey"
                        type="text"
                        v-model="contact.unique_key"
                        :placeholder="maskPlaceholder"
                        @input="applyMask"
                        style="flex: 4"
                    >
                </div>

                <div v-if="saving">
                    <p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Salvando contato...</strong></p>
                </div>
                <div v-else >
                    <button    
                        type="submit"
                        class="btn btn-success"
                        id="btn-save"
                        form="chamadoForm"
                        @click.prevent="saveContact()"
                    ><i class="fas fa-check"></i>
                        Salvar
                    </button>
                    <button 
                        type="submit"
                        class="btn btn-danger"
                        id="btn-cancel"
                        form="chamadoForm"
                        @click.prevent="resetContact()"
                    ><i class="fas fa-window-close fa-fw"></i>
                        Cancelar
                        </button>
                    
                </div>
            </form>
        </div>
    </section>
</template>
    
<script>

import {mapActions, mapGetters, mapMutations} from 'vuex';
import VueTheMask from 'vue-the-mask';
import axios from 'axios';
Vue.use(VueTheMask);

export default {
    name: "Contacts",
    data(){
        return {
            contact: {
                name: "",
                phone: "",
                unique_key: "",
                empresa: '',
                email: '',
                status: 1,
                filter: 1,
                wallet_group: "",
            },
            options: {
                placeholder: 'Insira o telefone',
                required: true
            },
            saving: false,
            idCpf: "cnpj",
            select_tipo: [],
            lengthTipo: 0,
            select_filter: [],
            lengthFilter: 0,
            emailValid: true
        }
    },
    components: {
        ...mapGetters(['getContacts']),
    },
    computed:{
		...mapGetters([
			'getContacts',
		]),
        maskPlaceholder() {
            if (this.idCpf === 'cpf') {
                return 'XXX.XXX.XXX-XX';
            } else if (this.idCpf === 'cnpj') {
                return 'XX.XXX.XXX/XXXX-XX';
            }else {
                return 'Id do contato';
            }
        }
    },
    created() {
      this.getTipos();
      this.getFilters();
    },
    methods:{
        applyMask() {
            if (this.idCpf === 'cpf') {
                let value = this.contact.unique_key.replace(/\D/g, '').slice(0, 11);
                this.contact.unique_key = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
            } else if (this.idCpf === 'cnpj') {
                let value = this.contact.unique_key.replace(/\D/g, '').slice(0, 14);
                this.contact.unique_key = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
            }
        },
        validateEmail() {
            if (!this.contact.email) {
                this.emailValid = true;
                return;
            }

            const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
            this.emailValid = emailPattern.test(this.contact.email);
        },

        validatePhoneNumber(phone) {
        const digits = phone.replace(/\D/g, '');

        if (!digits.startsWith('55')) {
            return true;
        }

        const regexBR = /^55\d{2}9\d{8}$/;
        return regexBR.test(digits);
        },


        checkForm: function(){
            if (this.contact.name == ''){
                Swal.fire({
                    html: 'O campo "Nome" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false  
            }
            if(this.contact.status == 1 || this.contact.status == ''){
                Swal.fire({
                    html: 'O campo "Tipo" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false  
            }
            if(this.contact.status == 2 && this.contact.filter == 1 || this.contact.filter == ''){
                Swal.fire({
                    html: 'O campo "Filtro" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false  
            }
            if (this.contact.phone == ''){
                Swal.fire({
                    html: 'O campo "Telefone" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false  
            }
            if (this.validatePhoneNumber(this.contact.phone)) {
                return true;
            } else {
                Swal.fire({
                    html: 'O campo "Telefone" está com formato inválido',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false;
            }
        },
        saveContact: function(){
            if(this.checkForm()){
                this.saving = true
                axios.post("dialer/saveContact", this.contact).then(data=> {
                    if(data.data.passed == false){
                        let str = '';
                        Object.keys(data.data.errors).forEach(key => {
                            str += data.data.errors[key];
                        });
                        Swal.fire({
                            type: "warning",
                            title: "Não foi possível inserir o cliente a base",
                            text: str
                        }).then(comfirm =>{
                            this.saving = false
                        })
                        return;
                    }
                    Swal.fire({
                        type: "success",
                        title: "Feito!",
                        text: "Contato salvo com sucesso!"
                    }).then(comfirm =>{
                  	  this.saving = false;
                  	  this.contact.name = "";
                  	  this.contact.phone = "";
                      this.contact.unique_key =  "";
                      this.contact.empresa = "";
                      this.contact.email = "";
                      this.contact.status = 1;
                      this.contact.filter = 1;
                      this.contact.wallet_group = "";
                      this.idCpf = "cnpj";
	            });
                    
                })
            }
        },

        resetContact: function(){
            Swal.fire({
                title: 'Deseja descartar as informações?',
                text: 'Você perderá as alterações não salvas!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: 'rgb(28,134,154)',
                confirmButtonText: 'Sim, descartar',
                cancelButtonText: 'Voltar ao formulário'
            }).then((result) => {
                if(result.value){
                    this.contact.name = "";
                    this.contact.phone = "";
                    this.contact.unique_key = '';
                    this.contact.empresa = "";
                    this.contact.email = "";
                    this.contact.wallet_group = "";
                    this.idCpf = "cnpj";
                }
            })
        },
        getTipos (){
          axios.get('dialer/contatos/getTipoContato').then(({data}) => {
            this.lengthTipo = data.length;
            this.select_tipo = data.filter(type => type.id !== 1);
          });
        },

        getFilters() {
          axios.get('dialer/contatos/getFilterContato').then(({data}) => {
            this.lengthFilter = data.length;
            this.select_filter = data.filter(filter => filter.id !== 1);
          })
        },
    },
    watch: {
        idCpf() {
            this.contact.unique_key = "";
        }
    }
}
</script>

<style scoped>
    .formHeader {
        background-color: rgb(28,134,154);
        border-top: 3px solid #f38630;
        color: white;
        padding: 0.2em;
        display: flex;
        border-radius: 20px 20px 0px 0px
    }

    .input-group{
        width: 90%;
        align-self: center;
        line-height: 2.55;
    }

    #container-contacts-form{
        margin: 3em;
        width: 40vw;
        border: solid 2px lightgray;
        border-radius: 25px;
        text-align: center;
        flex-direction: column;
        margin: 10px;
        padding: 0
    }

    #saving {
        color: rgb(28,134,154);
        font-size: 16px;
        text-align: center
    }

    #div-title {
        display: flex;
        flex-direction: column;
        margin: 20px;
    }

    #contacts-form{
        display: flex;
        flex-direction: column;
        text-align: center;
    }

    #buttonGroup {
        display: flex;
        justify-content: center;
    }

    #btn-save {
        border: solid 2px #008000;
        border-radius: 20px;
        background-color: #008000;
        color: white;
        transition: 0.5s
    }
    
    #btn-save:hover {
        color: #008000;
        background-color: white;

    }

    #btn-cancel {
        border: solid 2px #b30000;
        border-radius: 20px;
        background-color: #b30000;
        color: white;
        transition: 0.5s
    }
    
    #btn-cancel:hover {
        color: #b30000;
        background-color: white;

    }

    #phone-input{
        height: 2.5em;
        align-self: center;
        flex: 3;
    }

    .input-group label {
        width: 90px;
    }

    section {
        display: flex;
        justify-content: center;
    }

    h2 {
        color: rgb(28,134,154)
    }

    label{
        margin: 10px;
        font-size: 16px;
        font-weight: 500;
    }

    select {
        align-self: center;
    }

    input {
        width: 40px;
        align-self: center;
    }

    button {
        width: 120px;
        margin: 20px;
        border-radius: 10px !important
    }
</style>
